/**
 * Mock Data for Thaklis Finance Overview
 * Phase 9.1 - Dummy page implementation
 */

export const MOCK_FINANCE_OVERVIEW = {
  // Card 1: Total Bank Balance
  totalBankBalance: 122500.00,
  activeBankAccounts: 3,

  // Card 2: Customer Payments IN
  totalCustomerPaymentsIN: 125680.00,
  customerPaymentCount: 20,
  onlinePayments: 85000.00,
  onlinePaymentCount: 12,
  offlinePayments: 40680.00,
  offlinePaymentCount: 8,

  // Card 3: Customer Wallet Balances (NEW)
  totalCustomerWalletBalances: 45320.00,
  customersWithBalance: 8,
  averageWalletBalance: 5665.00,

  // Card 4: Pending Service Partner Payments
  pendingServicePartnerPayments: 7700.00,
  pendingServicePartnerCount: 2,

  // Card 5: Pending Channel Partner Commissions
  pendingChannelPartnerCommissions: 3520.00,
  pendingCommissionCount: 2,

  // Master Wallet
  // Formula: Total Bank Balance - Customer Wallet Balances
  // 122,500.00 - 45,320.00 = 77,180.00
  thaklisMasterWallet: 77180.00,

  // Revenue & Profitability
  totalRevenue: 125450.00,
  revenueChangePercent: 6.7,
  grossProfit: 27090.00,
  grossProfitMargin: 21.6,
  netProfit: 21672.00,
  pendingCustomerPayments: 15350.00,
  pendingCustomerPaymentCount: 4,

  // Tax Tracking (NEW - Placeholder for future implementation)
  taxCollectedFromCustomers: 12500.00,
  taxPaidToGovernment: 8000.00,
  taxLiability: 4500.00,  // taxCollectedFromCustomers - taxPaidToGovernment
  taxTransactionCount: 15,
};

// Bank Accounts Detail (for drill-down modal)
export const MOCK_BANK_ACCOUNTS = [
  {
    id: '1',
    bankName: 'NBD Bank',
    type: 'OPERATIONS',
    accountNumber: '82323323232',
    balance: 45000.00,
    currency: 'AED',
    status: 'ACTIVE',
    iban: 'AE070331234567890123456',
    swiftCode: 'EBILAEAD',
  },
  {
    id: '2',
    bankName: 'ICICI Bank',
    type: 'OPERATIONS',
    accountNumber: '23232323',
    balance: 32500.00,
    currency: 'AED',
    status: 'ACTIVE',
    iban: 'AE460331234567890123457',
    swiftCode: 'ICICINBB',
  },
  {
    id: '3',
    bankName: 'First Abu Dhabi Bank (FAB)',
    type: 'STRIPE_SETTLEMENT',
    accountNumber: 'AE33444555666',
    balance: 45000.00,
    currency: 'AED',
    status: 'ACTIVE',
    iban: 'AE330331234567890123458',
    swiftCode: 'NBADAEAA',
  },
];

// Customer Payments - ONLINE (for drill-down modal)
export const MOCK_ONLINE_PAYMENTS = [
  {
    id: '1',
    customerName: 'Tech Innovations LLC',
    amount: 25000.00,
    paymentMethod: 'STRIPE',
    transactionRef: 'STR-20251118-001',
    date: '2025-11-18T10:30:00Z',
    status: 'COMPLETED',
  },
  {
    id: '2',
    customerName: 'Elite Business Consultants',
    amount: 18500.00,
    paymentMethod: 'PAYPAL',
    transactionRef: 'PP-20251117-045',
    date: '2025-11-17T14:20:00Z',
    status: 'COMPLETED',
  },
  {
    id: '3',
    customerName: 'Global Trade Partners',
    amount: 15000.00,
    paymentMethod: 'CREDIT_CARD',
    transactionRef: 'CC-20251116-123',
    date: '2025-11-16T09:15:00Z',
    status: 'COMPLETED',
  },
  {
    id: '4',
    customerName: 'Horizon Ventures',
    amount: 12000.00,
    paymentMethod: 'BANK_TRANSFER_ONLINE',
    transactionRef: 'BTO-20251115-089',
    date: '2025-11-15T16:45:00Z',
    status: 'COMPLETED',
  },
  {
    id: '5',
    customerName: 'Prime Solutions',
    amount: 14500.00,
    paymentMethod: 'STRIPE',
    transactionRef: 'STR-20251114-034',
    date: '2025-11-14T11:30:00Z',
    status: 'COMPLETED',
  },
];

// Customer Payments - OFFLINE (for drill-down modal)
export const MOCK_OFFLINE_PAYMENTS = [
  {
    id: '6',
    customerName: 'thaklis',
    amount: 12000.00,
    paymentMethod: 'BANK_TRANSFER',
    bankReference: 'REF-4a5df',
    date: '2025-11-10T08:00:00Z',
    status: 'PENDING_APPROVAL',
    depositSlip: 'deposit-001.pdf',
  },
  {
    id: '7',
    customerName: 'Al Sada Typing Center',
    amount: 8500.00,
    paymentMethod: 'CASH_DEPOSIT',
    bankReference: 'CASH-20251109-001',
    date: '2025-11-09T13:20:00Z',
    status: 'APPROVED',
  },
  {
    id: '8',
    customerName: 'Emirates Document Services',
    amount: 10180.00,
    paymentMethod: 'BANK_TRANSFER',
    bankReference: 'BT-20251108-456',
    date: '2025-11-08T10:45:00Z',
    status: 'APPROVED',
  },
  {
    id: '9',
    customerName: 'Visa Solutions Hub',
    amount: 5000.00,
    paymentMethod: 'CHEQUE',
    bankReference: 'CHQ-789456',
    date: '2025-11-07T09:30:00Z',
    status: 'PENDING_CLEARANCE',
  },
  {
    id: '10',
    customerName: 'Professional Services Co',
    amount: 5000.00,
    paymentMethod: 'BANK_TRANSFER',
    bankReference: 'BT-20251106-234',
    date: '2025-11-06T15:10:00Z',
    status: 'APPROVED',
  },
];

// Customer Payments - By Customer (for drill-down modal)
export const MOCK_PAYMENTS_BY_CUSTOMER = [
  {
    customerId: '1',
    customerName: 'Tech Innovations LLC',
    totalPayments: 45200.00,
    paymentCount: 3,
    lastPaymentDate: '2025-11-18T10:30:00Z',
    lastPaymentAmount: 25000.00,
  },
  {
    customerId: '2',
    customerName: 'Elite Business Consultants',
    totalPayments: 28500.00,
    paymentCount: 2,
    lastPaymentDate: '2025-11-17T14:20:00Z',
    lastPaymentAmount: 18500.00,
  },
  {
    customerId: '3',
    customerName: 'thaklis',
    totalPayments: 22000.00,
    paymentCount: 2,
    lastPaymentDate: '2025-11-10T08:00:00Z',
    lastPaymentAmount: 12000.00,
  },
  {
    customerId: '4',
    customerName: 'Global Trade Partners',
    totalPayments: 15000.00,
    paymentCount: 1,
    lastPaymentDate: '2025-11-16T09:15:00Z',
    lastPaymentAmount: 15000.00,
  },
  {
    customerId: '5',
    customerName: 'Horizon Ventures',
    totalPayments: 12000.00,
    paymentCount: 1,
    lastPaymentDate: '2025-11-15T16:45:00Z',
    lastPaymentAmount: 12000.00,
  },
];

// Customer Wallet Balances (NEW - for drill-down modal)
export const MOCK_CUSTOMER_WALLET_BALANCES = [
  {
    customerId: '1',
    customerName: 'Tech Innovations LLC',
    walletBalance: 12500.00,
    lastTopupDate: '2025-11-18T10:30:00Z',
    lastTopupAmount: 25000.00,
    totalDeposited: 75000.00,
    totalSpent: 62500.00,
    status: 'ACTIVE',
  },
  {
    customerId: '2',
    customerName: 'Elite Business Consultants',
    walletBalance: 8200.00,
    lastTopupDate: '2025-11-17T14:20:00Z',
    lastTopupAmount: 18500.00,
    totalDeposited: 45000.00,
    totalSpent: 36800.00,
    status: 'ACTIVE',
  },
  {
    customerId: '3',
    customerName: 'thaklis',
    walletBalance: 6500.00,
    lastTopupDate: '2025-11-10T08:00:00Z',
    lastTopupAmount: 12000.00,
    totalDeposited: 30000.00,
    totalSpent: 23500.00,
    status: 'ACTIVE',
  },
  {
    customerId: '4',
    customerName: 'Global Trade Partners',
    walletBalance: 5800.00,
    lastTopupDate: '2025-11-16T09:15:00Z',
    lastTopupAmount: 15000.00,
    totalDeposited: 35000.00,
    totalSpent: 29200.00,
    status: 'ACTIVE',
  },
  {
    customerId: '5',
    customerName: 'Horizon Ventures',
    walletBalance: 4320.00,
    lastTopupDate: '2025-11-15T16:45:00Z',
    lastTopupAmount: 12000.00,
    totalDeposited: 28000.00,
    totalSpent: 23680.00,
    status: 'ACTIVE',
  },
  {
    customerId: '6',
    customerName: 'Al Sada Typing Center',
    walletBalance: 3500.00,
    lastTopupDate: '2025-11-09T13:20:00Z',
    lastTopupAmount: 8500.00,
    totalDeposited: 22000.00,
    totalSpent: 18500.00,
    status: 'ACTIVE',
  },
  {
    customerId: '7',
    customerName: 'Emirates Document Services',
    walletBalance: 2800.00,
    lastTopupDate: '2025-11-08T10:45:00Z',
    lastTopupAmount: 10180.00,
    totalDeposited: 18000.00,
    totalSpent: 15200.00,
    status: 'ACTIVE',
  },
  {
    customerId: '8',
    customerName: 'Visa Solutions Hub',
    walletBalance: 1700.00,
    lastTopupDate: '2025-11-07T09:30:00Z',
    lastTopupAmount: 5000.00,
    totalDeposited: 12000.00,
    totalSpent: 10300.00,
    status: 'ACTIVE',
  },
];

// Pending Service Partner Payments (for drill-down modal)
export const MOCK_PENDING_PARTNER_PAYMENTS = [
  {
    id: '1',
    partnerId: 'p1',
    partnerName: 'Al Sada Typing Center',
    amount: 5200.00,
    ticketCount: 2,
    oldestPendingDate: '2025-10-18',
    services: [
      { serviceType: 'Visa Renewal', amount: 2500.00, tickets: 1 },
      { serviceType: 'New Visa Application', amount: 2700.00, tickets: 1 },
    ],
  },
  {
    id: '2',
    partnerId: 'p2',
    partnerName: 'Emirates Document Services',
    amount: 2500.00,
    ticketCount: 1,
    oldestPendingDate: '2025-10-25',
    services: [
      { serviceType: 'Document Attestation', amount: 2500.00, tickets: 1 },
    ],
  },
];

// Pending Channel Partner Commissions (for drill-down modal)
export const MOCK_PENDING_COMMISSIONS = [
  {
    id: '1',
    channelPartnerId: 'cp1',
    channelPartnerName: 'Elite Business Consultants',
    amount: 2270.00,
    ticketCount: 3,
    oldestPendingDate: '2025-10-20',
    services: [
      { serviceType: 'Visa Renewal', amount: 1200.00, tickets: 1 },
      { serviceType: 'New Visa Application', amount: 850.00, tickets: 1 },
      { serviceType: 'Document Translation', amount: 220.00, tickets: 1 },
    ],
  },
  {
    id: '2',
    channelPartnerId: 'cp2',
    channelPartnerName: 'Global Partners Network',
    amount: 1250.00,
    ticketCount: 1,
    oldestPendingDate: '2025-10-28',
    services: [
      { serviceType: 'Business Setup', amount: 1250.00, tickets: 1 },
    ],
  },
];

// All Transactions (for transaction tabs)
export const MOCK_ALL_TRANSACTIONS = [
  {
    date: '2025-11-18',
    type: 'CUSTOMER_PAYMENT',
    description: 'Payment from Tech Innovations LLC - Visa Renewal',
    reference: 'STR-20251118-001',
    amount: 25000.00,
    status: 'COMPLETED',
    badge: 'Customer Payment',
  },
  {
    date: '2025-11-17',
    type: 'SERVICE_PARTNER_PAYMENT',
    description: 'Payment to Al Sada Typing Center - Service Completion',
    reference: 'PAY-SP-20251017-001',
    amount: -2500.00,
    status: 'COMPLETED',
    badge: 'Service Partner Payment',
  },
  {
    date: '2025-11-16',
    type: 'COMMISSION_PAYMENT',
    description: 'Commission to Elite Business Consultants',
    reference: 'PAY-CP-20251016-001',
    amount: -1250.00,
    status: 'COMPLETED',
    badge: 'Channel Partner Commission',
  },
  {
    date: '2025-11-15',
    type: 'EXPENSE',
    description: 'Office Rent - November 2025',
    reference: 'EXP-20251015-001',
    amount: -8000.00,
    status: 'COMPLETED',
    badge: 'Expense',
  },
  {
    date: '2025-11-14',
    type: 'BANK_DEPOSIT',
    description: 'Cash deposit to Emirates NBD',
    reference: 'DEP-20251014-001',
    amount: 5000.00,
    status: 'COMPLETED',
    badge: 'Bank Deposit',
  },
  {
    date: '2025-11-13',
    type: 'BANK_WITHDRAWAL',
    description: 'Cash withdrawal for petty cash',
    reference: 'WD-20251013-001',
    amount: -1000.00,
    status: 'COMPLETED',
    badge: 'Bank Withdrawal',
  },
];
